import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {SessionStorageService} from '@services/session-storage.service';
import {storageKey} from '@constants/storage.constants';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(SessionStorageService);
  const token = storage.get(storageKey.token);

  if (token) {
    const cloned = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
    return next(cloned);
  }

  return next(req);
};
